import analytics from '@utils/analytics';
import React, { useEffect, useRef } from 'react';
const SortByOption = (props) => {
    const { index, option, currentSortOption, toggleSort, sortItems, focusOption, focusedOption, fromSearch } = props;
    const optionRef = useRef();
    const fromKeyboard = document.documentElement.getAttribute('data-whatintent') == 'keyboard';
    useEffect(() => {
        if (focusedOption === index && fromKeyboard) {
            setTimeout(() => {
                optionRef.current.focus();
            }, 50);
        }
    }, [focusedOption]);
    return (React.createElement("li", { ref: optionRef, onClick: () => {
            sortItems(option);
            if (option.id != (currentSortOption === null || currentSortOption === void 0 ? void 0 : currentSortOption.id)) {
                fromSearch ? analytics.searchSortBy(option.displayName) : analytics.sortBy(option.displayName);
            }
        }, onKeyDown: (e) => {
            if (e.key == 'Enter') {
                e.preventDefault();
                sortItems(option);
                if (option.id != (currentSortOption === null || currentSortOption === void 0 ? void 0 : currentSortOption.id)) {
                    fromSearch ? analytics.searchSortBy(option.displayName) : analytics.sortBy(option.displayName);
                }
            }
            else if (e.key == 'Escape') {
                e.preventDefault();
                toggleSort();
                setTimeout(() => {
                    var _a;
                    (_a = document.querySelector('#sortButton')) === null || _a === void 0 ? void 0 : _a.focus();
                }, 50);
            }
            else if (e.key == 'Tab') {
                toggleSort();
            }
            else if (e.key == 'ArrowUp') {
                e.preventDefault();
                // console.log('ArrowUp');
                focusOption('prev');
            }
            else if (e.key == 'ArrowDown') {
                e.preventDefault();
                // console.log('ArrowDown');
                focusOption('next');
            }
        }, role: "option", id: option.id, key: option.id, "aria-selected": option.id === (currentSortOption === null || currentSortOption === void 0 ? void 0 : currentSortOption.id), className: "sort__option", tabIndex: -1 },
        React.createElement("span", null, option.displayName)));
};
export default SortByOption;
